import { MainNav, NavLinkElement } from "@/routes/_components/main-nav";
import { Toaster as DeprecatedToaster } from "@/shared/components/ui/toaster";
import { Search } from "@/routes/_components/search/search";
import { MainPage, MainPageHeader } from "@/routes/_components/main-page";
import { Logo } from "@/routes/_components/logo";
import { UserMenu } from "@/routes/_components/user-menu";
import { Outlet } from "react-router";
import { Toaster } from "@/shared/components/ui/sonner";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { UserFeedbackButton } from "@/services/backend/user-feedback/components/user-feedback-button";

export default function Root() {
  const canAccessDashboard = useFeatureAuth("gsm.dashboard");
  const canAccessProcesses = useFeatureAuth("gsm.processes");
  const canAccessCommitments = useFeatureAuth("gsm.commitments");
  const canAccessInvoices = useFeatureAuth("gsm.invoices");
  const canAccessCustomers = useFeatureAuth("gsm.customers");
  const canAccessBaseData = useFeatureAuth("portal.basedata");

  const invoicesIsReleased = useBooleanFlagValue("gsm.invoices", true);

  const navList: NavLinkElement[] = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/processes", label: "Vorgänge" },
    { to: "/commitments", label: "Sollstellungen" },
    { to: "/invoices", label: "Rechnungsstellung" },
    { to: "/customers", label: "Kunden" },
    { to: "/base-data", label: "Stammdaten" },
  ].filter((item) => {
    switch (item.to) {
      case "/dashboard":
        return canAccessDashboard;
      case "/processes":
        return canAccessProcesses;
      case "/commitments":
        return canAccessCommitments;
      case "/invoices":
        return canAccessInvoices && invoicesIsReleased;
      case "/customers":
        return canAccessCustomers;
      case "/base-data":
        return canAccessBaseData;
      default:
        return true;
    }
  });

  return (
    <MainPage>
      <MainPageHeader>
        <Logo />
        <MainNav navList={navList} />
        <div className="ml-auto flex items-center space-x-4">
          <UserFeedbackButton />
          <Search />
          <UserMenu />
        </div>
      </MainPageHeader>
      <Outlet />
      <DeprecatedToaster />
      <Toaster />
    </MainPage>
  );
}
